<template lang="html">
  <div class="col-lg-9 col-page-content page-plans">
    <div class="row">

      <div class="col-12">
        <!-- Paso 1 -->
        <div class="box-bubble" v-if="step == 1">
          <!-- <h6 class="step-title">Selecciona un plan</h6> -->

          <div class="row">
            <div class="col-12 mb-0 box-acc-title-s1">
              <h4>Selecciona un plan</h4>
              <hr />
            </div>

            <div class="col-12 box-plans">
              <div class="row">
                <!-- <div class="col-md-6 col-xl-4 col-plan" v-bind:class="{ 'active' : plan == 1, 'disabled' : currentPlan == 1 }">
                  <div class="box">
                    <div class="box-image">
                      <img src="public/images/pages/account/plan-1.svg">
                    </div>

                    <div class="box-info">
                      <h3 class="number">5</h3>
                      <h5 class="subt">Vacantes</h5>
                      <h5 class="price">$0.00 <small>Mensual</small></h5>

                      <div class="descr">
                        <ul class="">
                          <li>Característica numero 1.</li>
                          <li>Característica numero 2.</li>
                        </ul>
                      </div>
                    </div>

                    <div class="box-buttons">
                      <a class="btn btn-buy current" v-if="currentPlan == 1">Plan Actual</a>
                      <button class="btn btn-buy new" v-else @click="plan = 1">Comprar</button>
                    </div>
                  </div>
                </div> -->

                <div class="col-md-6 col-xl-4 col-plan" v-bind:class="{ 'active' : form.plans_id == p.id, 'disabled' : form.plans_id == p.id }" v-for="(p,indxp) in plans" :key="indxp">
                  <div class="box" @click="form.plans_id = p.id">
                    <div class="box-image">
                      <img src="public/images/pages/account/plan-2.svg">
                    </div>

                    <div class="box-info">
                      <h3 class="number">{{p.numero_vacantes}}</h3>
                      <h5 class="subt">Vacantes</h5>
                      <h5 class="price">{{p.precio}} <small>Mensual</small></h5>

                      <div class="descr">
                        <!-- <ul class="">
                          <li>Característica numero 1.</li>
                          <li>Característica numero 2.</li>
                          <li>Característica numero 3.</li>
                          <li>Otra característica más.</li>
                        </ul> -->
                        {{ p.descripcion }}
                      </div>
                    </div>

                    <div class="box-buttons">
                      <a class="btn btn-buy current" v-if="form.plans_id == p.id">Plan Actual</a>
                      <button class="btn btn-buy new" v-else>Comprar</button>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-md-6 col-xl-4 col-plan" v-bind:class="{ 'active' : plan == 2, 'disabled' : currentPlan == 2 }">
                  <div class="box" @click="plan = 2">
                    <div class="box-image">
                      <img src="public/images/pages/account/plan-2.svg">
                    </div>

                    <div class="box-info">
                      <h3 class="number">10</h3>
                      <h5 class="subt">Vacantes</h5>
                      <h5 class="price">$400.00 <small>Mensual</small></h5>

                      <div class="descr">
                        <ul class="">
                          <li>Característica numero 1.</li>
                          <li>Característica numero 2.</li>
                          <li>Característica numero 3.</li>
                          <li>Otra característica más.</li>
                        </ul>
                      </div>
                    </div>

                    <div class="box-buttons">
                      <a class="btn btn-buy current" v-if="currentPlan == 2">Plan Actual</a>
                      <button class="btn btn-buy new" v-else>Comprar</button>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-xl-4 col-plan" v-bind:class="{ 'active' : plan == 3, 'disabled' : currentPlan == 3 }">
                  <div class="box" @click="plan = 3">
                    <div class="box-image">
                      <img src="public/images/pages/account/plan-3.svg">
                    </div>

                    <div class="box-info">
                      <h3 class="number">20</h3>
                      <h5 class="subt">Vacantes</h5>
                      <h5 class="price">$600.00 <small>Mensual</small></h5>

                      <div class="descr">
                        <ul class="">
                          <li>Característica numero 1.</li>
                          <li>Característica numero 2.</li>
                          <li>Característica numero 3.</li>
                          <li>Otra característica más.</li>
                        </ul>
                      </div>
                    </div>

                    <div class="box-buttons">
                      <a class="btn btn-buy current" v-if="currentPlan == 3">Plan Actual</a>
                      <button class="btn btn-buy new" v-else>Comprar</button>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>

            <div class="col-12 text-center box-nav">
              <!-- <a class="btn mx-1 btn-squ-1 gray">Anterior</a> -->
              <a class="btn mx-1 btn-squ-1" @click="step = 2">Siguiente</a>
            </div>
          </div>
        </div>
        <!--  -->

        <!-- Paso 2 -->
        <div class="box-bubble box-step-2" v-show="step == 2">
          <div class="col-12 mb-3 box-acc-title-s1">
            <h4>Selecciona una forma de pago</h4>
            <hr />
          </div>
          <!-- <h6 class="step-title">Selecciona una forma de pago</h6> -->

          <div class="row mb-4 payment-options-container">
            <div class="col-6 col-sm-4 col-box" @click="changePaymentMe('tarjetas')">
              <div class="box" v-bind:class="{ active: form.tipoPago == 'tarjetas' }">
                <h6>Tarjeta de crédito o débito</h6>
                <p class="icons">
                  <i class="fab fa-cc-visa"></i>
                  <i class="fab fa-cc-mastercard"></i>
                </p>
              </div>
            </div>

            <!-- <div class="col-6 col-sm-4 col-box" @click="changePaymentMe('transferencia')">
              <div class="box" v-bind:class="{ active: form.tipoPago == 'transferencia' }">
                <h6>Deposito o transferencia</h6>
                <p class="icons">
                  <i class="fas fa-money-check-alt"></i>
                  <i class="fas fa-money-bill"></i>
                </p>
              </div>
            </div>

            <div class="col-6 col-sm-4 col-box" @click="changePaymentMe('paypal')">
              <div class="box" v-bind:class="{ active: form.tipoPago == 'paypal' }">
                <h6>Pago a traves de Paypal</h6>
                <p class="icons">
                  <i class="fab fa-paypal"></i>
                </p>
              </div>
            </div> -->
          </div>

          <!-- Pago 1, con tarjetas -->
          <div class="row mx-0 no-gutters" v-if="form.tipoPago == 'tarjetas'">
            <div class="col-12">
                <div class="alert alert-primary" role="alert">
                    Sus datos de tarjeta de debito o de credito no son almacenados por nuestro sistema y son procesados de manera segura y encriptada. En cada pago sera necesario agregar nuevamente estos datos.
                </div>

                <label class="mt-3">Detalles de tarjeta:</label>
                <div id="cardElement"></div>
                <small class="form text text-muted" id="cardErrors" role="alert"></small>

               
            </div>
          </div>
          <!--  -->

          <!-- Pago 2, con transferencia bancaria -->
          <div class="col-12 text-center" v-if="form.tipoPago == 'transferencia'">
            <p class="mb-3">
              <img src="public/images/hsbc.png" width="200">
            </p>
            <p><strong>BANCO:</strong> HSBC</p>
            <p><strong>TITULAR:</strong> PERSONA XYZ</p>
            <p><strong>CLABE INTERBANCARIA:</strong> 012364000550000</p>
            <p><strong>NÚMERO DE CUENTA:</strong>121000000050000</p>
            <hr />
            <p>
              Favor de enviarnos el comprobante de pago al siguiente correo: <br />
              <strong>pago@jobusco.com</strong>
            </p>
          </div>
          <!--  -->

          <!-- Pago 3, con paypal -->
          <div class="col-12 text-center" v-if="form.tipoPago == 'paypal'">
            <p>Depósito por medio de paypal.</p>

            <hr />
            <p>
              Favor de enviarnos el comprobante de pago al siguiente correo: <br />
              <strong>pago@jobusco.com</strong>
            </p>
          </div>
          <!--  -->

          <div class="col-12 text-center box-nav">
            <a class="btn mx-1 btn-squ-1 gray" @click="step = 1">Anterior</a>
            <a class="btn mx-1 btn-squ-1" @click="payStripe()">Pagar</a>
          </div>
        </div>
        <!--  -->

        <div class="box-bubble pb-4 box-step-3" v-if="step == 3">
          <div class="col-12 mb-3 box-acc-title-s1">
            <h4>Pago finalizado</h4>
            <hr />
          </div>

          <div class="box-success">
            <div class="success-checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>
          </div>
          <h4 class="text-center f-w-700 txt-graydark">GRACIAS POR TU COMPRA <br>ID de compra: {{ order_id }}<br>Recibirás un correo con la confirmación de tu compra</h4>
        </div>

      </div>
    </div>
    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
        <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div v-html="modal.msg"></div>
        <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
         
          <b-button class="btn btn-success" slot="button" @click="toHome">Ir a vacantes <i class="color-white fas fa-home"></i></b-button>
        </div>
      </sweet-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      step: 1,
      plan: null,
      currentPlan: null,

      form: {
        tipoPago: null,
        total:null,
        plans_id:null
      },
      plans:[],
      modal:{
        msg:'',
        icon:'',
        block:false,
      },
      stripe: {},

      order_id:null,
    }
  },
  watch:{
      'form.plans_id':function(){
          var price = null;
            for (let z = 0; z < this.plans.length; z++) {
                price = this.plans[z]['precio'];
              
            }
            this.form.total = price;
      },
      'form.tipoPago':function(){
        if(this.form.tipoPago == "tarjetas"){
          setTimeout(this.loadStripe, 50);
        }
      },
      
  },

  methods: {
      changePaymentMe(tipo){
        this.form.tipoPago = tipo;
      },
      getPlans(){
          axios.get(tools.url("/plans"))
          .then((response)=>{
                this.plans = response.data;
            }).catch((error)=>{
            });
      },
      loadStripe(){
        //sandbox key
        this.stripe = Stripe('pk_live_51MW0xNA2zVRZdk1qHeG6TuI3KYez08iUOldnWKufNQoB1jEctAYJ8bAWDanlrc7v2o6wXcmw5WeSSTmk3eH88Fca00DtrpR9OE');
        //this.stripe = Stripe('pk_test_51MW0xNA2zVRZdk1qgh7FzCnH1SnfHaeZctoeLpPiR9RDeVAOcW0c4OaxUlZeie3VuSpQDf8hd7lZdERpAWyITEBt00cCX2AxcM');

        this.elements = this.stripe.elements({locale: 'es'});
        this.cardElement = this.elements.create('card', {hidePostalCode: true});

        this.cardElement.mount("#cardElement");
        this.cardElement.addEventListener('change', ({ error }) => {
            const displayError = document.getElementById('cardErrors');
            if (error) {
              displayError.textContent = error.message;
            } else {
              displayError.textContent = '';
            }
        });
      },

      payStripe(){
        this.modal.block = true;
        this.modal.icon = '';
        this.modal.msg = 'Validando el metodo de pago. por favor espere...';
        this.$refs.modal.open();

        this.stripe.createPaymentMethod({
            type: 'card',
            card: this.cardElement,
            billing_details: { name: this.$root.user.name, email: this.$root.user.email }
          }).then((result)=>{
            if (result.error) {
              alert('Ocurrió un error con su tarjeta');
              this.desactivar = false;
            } else {
              const data  = { payment_method_id: result.paymentMethod.id, total: this.form.total, name: this.$root.name, email: this.$root.email };
              axios.post(tools.url('/stripe/Installments'),data).then((response)=>{
                  this.form.payment_intent_id = response.data.intent_id;
                  this.pagarStripe();
                });
            }
        });
      },

      pagarStripe: function(){

        this.modal.msg = 'Generando compra, por favor espere...';
        
        axios.post(tools.url('/stripe/pay'),{  order:this.form, user:this.$root.user}).then((response)=>{
           

            if(response.data.type === "success"){
              this.order_id = response.data.order_id;
              this.modal.block = false;
              this.$refs.modal.close();
              this.step = 3;
            }else{
              this.modal.block = false;
              this.modal.icon = "error";
              this.modal.msg = response.data.message;
              
            }
        }).catch((error)=>{
          this.modal.block = false;
          this.modal.msg = 'ERROR: No se pudo realizar el pago.';
          this.modal.icon = 'error';

          
        });
      },
      toHome(){
        this.modal.block = false;
        this.$refs.modal.close(); 
        this.$router.push('/cuenta-empresa/publicar-vacante')
      }

  },
  mounted(){
    this.getPlans();
    
  }
}
</script>
<style>
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
